import { useMemo } from "react";
import { useDebounce } from "./useDebounce";

export const useFilterPartners = (partners, filterTerm) => {
  const debouncedSearchTerm = useDebounce(filterTerm, 300);

  const foundPartners = useMemo(() => {
    if (!debouncedSearchTerm?.trim()) {
      return partners;
    }

    const searchTerm = debouncedSearchTerm.toLowerCase().trim();

    return partners.filter((partner) => {
      // Handle cases where title might be undefined or null
      const title = partner?.title;
      if (!title) return false;

      return title.toLowerCase().includes(searchTerm);
    });
  }, [partners, debouncedSearchTerm]);

  return foundPartners;
};
